// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"451d03a6","239":"f92ad4b1","389":"b3c46b9c","488":"a3e0ef97","732":"2552adce","977":"b0318538"}[chunkId] + ".chunk.js";
};